import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  Grid,
  Divider,
  MenuItem,
  TextField,
  Typography,
  TextareaAutosize,
  Table,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState } from "react";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import DeleteIcon from "@mui/icons-material/Delete";
import axios from "axios";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import CustomLabel from "../../../CustomLable";
import api from "../../../utils/Url";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { getISTDate } from "../../../utils/Constant";
import Languages from "../../../Languages";
import { Language } from "react-transliterate";
import "react-transliterate/dist/index.css";
import TranslateTextField from "../../../TranslateTextField";
import api2 from "../../../utils/Url2";
import AddIcon from "@mui/icons-material/Add";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { reloadResources } from "i18next";


type Props = {};
const VehicleTypeInfoAdd = (props: Props) => {
  let navigate = useNavigate();
  const { t } = useTranslation();
  const { defaultValues } = getISTDate();
  const [lang, setLang] = useState<Language>("en");
  const location = useLocation();
  const [toaster, setToaster] = useState(false);

  const [selectedOption, setSelectedOption] = useState(""); // Initialize with an appropriate default value
  const initialRowData = {
    "id": 0,
    "vehicleTypeId": 0,
    "petroId": 0,
    "sessionD1": 0,
    "sessionD2": 0,
    "petroName": "",
    "createdOn": defaultValues,
    "effectiveDate": defaultValues,
    "updateOn": defaultValues,
    "createdBy": "",
    "updatedBy": "",
    "ntRecord": ""
  };

  const validationSchema = Yup.object({
    petroName: Yup.string().required("Petrol Pump is required"),
    petroId: Yup.string().required("Petrol Pump ID is required"),
    VehicleTypeName: Yup.string().required("Vehicle Type Name is required"),
    vehicleTypeId: Yup.string().required("Vehicle Type ID is required"),
  });


  const [vehicleOption, setvehicleOption] = useState([
    { value: -1, label: t("text.vehicleTypeId") },
  ]);

  const [petrolOption, setpetrolOption] = useState([
    { value: -1, label: "Select Petrol Pump" },
  ]);


  const [typedPetrolPump, setTypedPetrolPump] = useState("");

  useEffect(() => {
    getVehicleData();
    getpetrolData();
  }, []);
  const getVehicleData = async () => {
    const collectData = {
      "vehicleTypeId": -1,
      "vehicleTypename": ""
    };
    const response = await api.post(`VehicleType/GetVehicleType`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["vehicleTypename"],
        value: data[index]["vehicleTypeId"],
      });
    }
    setvehicleOption(arr);
  };
  const [isDialogOpen, setDialogOpen] = useState(false);
  const [newPetrolPump, setNewPetrolPump] = useState("");


  const handleDialogOpen = () => setDialogOpen(true);
  const handleDialogClose = () => setDialogOpen(false);

  const savepetrolData = async () => {
    const collectData = {
      "id": 0,
      "petroPump": formik.values.petroName,
      "cityId": 0,
      "stateId": 0
    };
    console.log("741841659", collectData);

    formik.setFieldValue("petroName", "");
    const response = await api.post(`PetrolPump/AddUpdatePetrolPumpmaster`, collectData);
    if (response?.data) {
      toast.success(response?.data.message);
      console.log('message', response?.data.message)

    }
  };
  const getpetrolData = async () => {
    const collectData = {
      "id": -1,
      "petroPump": "",
      "cityId": 0,
      "stateId": 0
    };
    const response = await api.post(`PetrolPump/GetPetrolPump`, collectData);
    const data = response.data.data;
    const arr = [];
    for (let index = 0; index < data.length; index++) {
      arr.push({
        label: data[index]["petroPump"],
        value: data[index]["id"],
      });
    }
    setpetrolOption(arr);
  };

  const formik = useFormik({
    initialValues: {
      // "id": 0,
      // "vehicleTypeId": 0,
      // "petroId": 0,
      // "sessionD1": 0,
      // "sessionD2": 0,
      // "petroName": "",
      // "createdOn": defaultValues,
      // "effectiveDate":defaultValues ,
      // "updateOn": defaultValues,
      // "createdBy": "",
      // "updatedBy": "",
      // "ntRecord": "",


      "id": 0,
      "vehicleTypeId": 0,
      "petroId": 0,
      "sessionD1": 0,
      "sessionD2": 0,
      "petroName": "",
      "createdOn": defaultValues,
      "effectiveDate": defaultValues,
      "updateOn": defaultValues,
      "createdBy": "",
      "updatedBy": "",

      "vehicleTypeMaster": {
        "activeClass": "",
        "all": true,
        "showExisting": true,
        "isSuccess": true,
        "message": "",
        "srno": 0,
        "eScarp": true,
        "eScarpPrevValue": "aa",
        "css": "aa",
        "vehicleTypeId": 0,
        "vehicleTypename": "",
        "shortName": "",
        "vehicleCode": "",
        "createdBy": "aa",
        "updatedBy": "",
        "createdOn": defaultValues,
        "updatedOn": defaultValues,
        "checked": true
      },
      "vehicleTypeName": "",
      "srno": 0,
      "ntRecord": ""


      //     "id": 0,
      // "vehicleTypeId": 0,
      // "petroId": 0,
      // "sessionD1": 0,
      // "sessionD2": 0,
      // "petroName": "",
      // "createdOn": defaultValues,
      // "effectiveDate": defaultValues,
      // "updateOn": defaultValues,
      // "createdBy": "",
      // "updatedBy": "",
      // "vehicleTypeMaster": {
      //   "activeClass": "",
      //   "all": true,
      //   "showExisting": true,
      //   "isSuccess": true,
      //   "message": "",
      //   "srno": 0,
      //   "eScarp": true,
      //   "eScarpPrevValue": "",
      //   "css": "",
      //   "vehicleTypeId": 0,
      //   "vehicleTypename": "",
      //   "shortName": "",
      //   "vehicleCode": "",
      //   "createdBy": "",
      //   "updatedBy": "",
      //   "createdOn":defaultValues,
      //   "updatedOn":defaultValues ,
      //   "checked": true
      // },
      // "vehicleTypeName": "",
      // "srno": 0,
      // "ntRecord": ""

    },

    validationSchema: Yup.object({
      vehicleTypeId: Yup.string()
        .required("Vehicle Type is required"),


    }),

    onSubmit: async (values) => {
      const response = await api.post(`Vtypeinfo/AddUpdateVtypeinfo`, values);
      if (response.data.status === 1) {
        setToaster(false);
        toast.success(response.data.message);
        navigate("/vehiclemanagement/vehicletypeinfo");
      } else {
        setToaster(true);
        toast.error(response.data.message);
      }
    },
  });

  const back = useNavigate();

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          border: ".5px solid #FF7722",
          marginTop: "3vh",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.VehicleTypeInfoAdd")}
          </Typography>
          <Grid container justifyContent="flex-end">
            <Grid item lg={2} md={2} xs={12} marginTop={2}>
              <select
                className="language-dropdown"
                value={lang}
                onChange={(e) => setLang(e.target.value as Language)}
              >
                {Languages.map((l) => (
                  <option key={l.value} value={l.value}>
                    {l.label}
                  </option>
                ))}
              </select>
            </Grid>
          </Grid>
          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            <ToastApp />
            <Grid item xs={12} container spacing={2}>








              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.EffectiveDate")}
                      required={false}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="effectiveDate"
                  id="effectiveDate"
                  type="date"
                  value={formik.values.effectiveDate}
                  placeholder={t("text.EffectiveDate")}
                  onChange={formik.handleChange}
                  InputLabelProps={{ shrink: true }}
                />

              </Grid>


              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  id="vehicle-autocomplete"
                  options={vehicleOption}
                  fullWidth
                  size="small"
                  onChange={(event, newValue) => {
                    formik.setFieldValue("vehicleTypeName", newValue?.label || "");
                    formik.setFieldValue("vehicleTypeMaster.vehicleTypename", newValue?.label || "");
                    formik.setFieldValue("vehicleTypeId", newValue?.value);

                    formik.setFieldValue("VehicleTypeName", newValue?.label || "");
                    // formik.setFieldValue("VehicleTypeMaster.VehicleTypename", newValue?.label || "");
                    // formik.setFieldValue("VehicleTypeMaster.Css", "a");
                    // formik.setFieldValue("VehicleTypeMaster.CreatedBy", "a");
                    // formik.setFieldValue("VehicleTypeMaster.EScarpPrevValue", "a");


                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={<CustomLabel text={t("text.VehicleTypeName")} required={true} />}
                      error={formik.touched.vehicleTypeId && Boolean(formik.errors.vehicleTypeId)}
                      helperText={formik.touched.vehicleTypeId && formik.errors.vehicleTypeId}
                    />
                  )}
                />
                {formik.touched.vehicleTypeId && formik.errors.vehicleTypeId && (
                  <div style={{ color: "red", margin: "5px" }}>{formik.errors.vehicleTypeId}</div>
                )}

              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.Shift1")}
                      required={false}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="sessionD1"
                  id="sessionD1"
                  type="number"

                  placeholder={t("text.Shift1")}
                  onChange={formik.handleChange}
                />
              </Grid>

              <Grid item xs={12} sm={4} lg={4}>
                <TextField
                  label={
                    <CustomLabel
                      text={t("text.Shift2")}
                      required={false}
                    />
                  }
                  variant="outlined"
                  fullWidth
                  size="small"
                  name="sessionD2"
                  id="sessionD2"
                  type="number"
                  placeholder={t("text.Shift2")}
                  onChange={formik.handleChange}
                />
              </Grid>



              <Grid item xs={12} sm={4} lg={4}>


                <Autocomplete
                  disablePortal
                  options={[
                    ...petrolOption,
                    ...(typedPetrolPump && !petrolOption.some(opt => opt.label === typedPetrolPump)
                      ? [{ value: "add-new", label: `${typedPetrolPump}` }]
                      : []),
                  ]}
                  fullWidth
                  size="small"
                  onInputChange={(event, newValue) => {
                    setTypedPetrolPump(newValue);
                  }}
                  onChange={(event, newValue) => {
                    if (newValue?.value === "add-new") {
                      setDialogOpen(true);
                    } else {
                      formik.setFieldValue("petroName", newValue?.label);
                      formik.setFieldValue("petroId", newValue?.value);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={<CustomLabel text={t("text.PetrolPump")} />} />
                  )}
                />


              </Grid>

              <Dialog open={isDialogOpen} onClose={() => setDialogOpen(false)}>
                <DialogTitle>Add New Petrol Pump</DialogTitle>
                <DialogContent>
                  <TextField
                    label="Petrol Pump Name"
                    value={typedPetrolPump}
                    fullWidth
                    disabled
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={async () => {
                      try {
                        const collectData = {
                          id: 0,
                          petroPump: typedPetrolPump,
                          cityId: 0,
                          stateId: 0,
                        };
                        const response = await api.post(
                          `PetrolPump/AddUpdatePetrolPumpmaster`,
                          collectData
                        );
                        if (response.data) {
                          setpetrolOption((prev) => [
                            ...prev,
                            { value: response.data.id, label: typedPetrolPump },
                          ]);
                          setDialogOpen(false);
                          formik.setFieldValue("petroName", typedPetrolPump);
                          formik.setFieldValue("petroId", response.data.id);
                          toast.success(response.data.message);
                          window.location.reload()
                        }
                      } catch (error) {
                        toast.error("Failed to add Petrol Pump");
                      }
                    }}
                  >
                    Add
                  </Button>
                  <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
                </DialogActions>
              </Dialog>
              {formik.touched.petroName && formik.errors.petroName && (
                <div style={{ color: "red", margin: "5px" }}>{formik.errors.petroName}</div>
              )}


              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  disablePortal
                  options={[
                    ...petrolOption,
                    ...(typedPetrolPump && !petrolOption.some(opt => opt.label === typedPetrolPump)
                      ? [{ value: "add-new", label: `${typedPetrolPump}` }]
                      : []),
                  ]}
                  fullWidth
                  size="small"
                  onInputChange={(event, newValue) => {
                    setTypedPetrolPump(newValue);
                  }}
                  onChange={(event, newValue) => {
                    if (newValue?.value === "add-new") {
                      setDialogOpen(true);
                    } else {
                      formik.setFieldValue("petroName", newValue?.label);
                      formik.setFieldValue("petroId", newValue?.value);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={<CustomLabel text={t("text.PetrolPump")} />} />
                  )}
                />
              </Grid>

              <Dialog open={isDialogOpen} onClose={() => setDialogOpen(false)}>
                <DialogTitle>Add New Petrol Pump</DialogTitle>
                <DialogContent>
                  <TextField
                    label="Petrol Pump Name"
                    value={typedPetrolPump}
                    fullWidth
                    disabled
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={async () => {
                      try {
                        const collectData = {
                          id: 0,
                          petroPump: typedPetrolPump,
                          cityId: 0,
                          stateId: 0,
                        };
                        const response = await api.post(
                          `PetrolPump/AddUpdatePetrolPumpmaster`,
                          collectData
                        );
                        if (response.data) {
                          setpetrolOption((prev) => [
                            ...prev,
                            { value: response.data.id, label: typedPetrolPump },
                          ]);
                          setDialogOpen(false);
                          formik.setFieldValue("petroName", typedPetrolPump);
                          formik.setFieldValue("petroId", response.data.id);
                          toast.success(response.data.message);
                          window.location.reload()
                        }
                      } catch (error) {
                        toast.error("Failed to add Petrol Pump");
                      }
                    }}
                  >
                    Add
                  </Button>
                  <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
                </DialogActions>
              </Dialog>





              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="submit"
                  fullWidth
                  style={{
                    backgroundColor: `var(--header-background)`,
                    color: "white",
                    marginTop: "10px",
                  }}
                >
                  {t("text.save")}
                </Button>
              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  onClick={(e: any) => formik.resetForm()}
                >
                  {t("text.reset")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default VehicleTypeInfoAdd;